import React, { Fragment } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import i18n from "i18next";
import { useTranslation } from 'react-i18next';

import {daysdetails} from './imageLanguageHandler/daysdetails.js'; 
import {dropbox} from './imageLanguageHandler/dropbox.js'; 
import {dropboximages} from './imageLanguageHandler/dropboximages.js'; 
import {exercise} from './imageLanguageHandler/exercise.js';  
import {googlefit} from './imageLanguageHandler/googlefit.js';  
import {oura} from './imageLanguageHandler/oura.js';  
import {sleep} from './imageLanguageHandler/sleep.js'; 

function Interpretation() {
  const { t } = useTranslation('help');
  return (
    <Fragment>
      <h1>{t('Interpretation')}</h1>
      <p>{t('Estimated reading time')} 8 {t('minutes.')}</p>
      <section id="balance">
        <h2>{t('Learn from the graphs')}</h2>
        <p>
          <Link to="#helpTips">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Interpretation-LearnFromGraphsChapter1')} <a
          href={t('Interpretation-LearnFromGraphsChapter1Link')}
          >{t('Interpretation-LearnFromGraphsChapter1LinkText')}</a> {t('Interpretation-LearnFromGraphsChapter1End')}
        </p>
      </section>
      {/*
        <section>
          <h2>Liikunnan vaikutus</h2>
        </section>
        <section>
          <h2>Vireystilan seuraaminen</h2>
        </section>
      */}
      <section id="images">
        <h2>{t('Add meal photos')}</h2>
        <p>
          <Link to="#helpTips">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter1')} 
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter2')}
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter3')}<br />
          <ol>
            <li>
              {t('Interpretation-AddMealPhotosStep1')}
            </li>
            <li>
              {t('Interpretation-AddMealPhotosStep2')}
            </li>
            <li>
              {t('Interpretation-AddMealPhotosStep3')}
            </li>
            <li>
              {t('Interpretation-AddMealPhotosStep4')}
            </li>
          </ol>
        </p>
        <p>
          <img 
            src={dropbox[i18n.language]?.() || dropbox['en']()}
            alt={t('Connecting to Dropbox')} 
          />
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter4')}
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter5')}
        </p>
        <p>
          <img 
            src={dropboximages[i18n.language]?.() || dropboximages['en']()}
            alt={t('Meal photos in the Dropbox')}
          />
        </p>
        <p>
          {t('Interpretation-AddMealPhotosChapter6')}
        </p>
        <p>              
          {t('Interpretation-AddMealPhotosChapter7')}
        </p>
        <p>
          <img 
            src={daysdetails[i18n.language]?.() || daysdetails['en']()}
            alt={t('Meal photon in the daily view')}
          />
        </p>
      </section>
      <section id="exercise">
        <h2>{t('Add exercise information')}</h2>
        <p>
          <Link to="#helpTips">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Interpretation-AddExerciseInfoChapter1')} 
        </p>
        <p>
          {t('Interpretation-AddExerciseInfoChapter2')}
        </p>
        <p>
          {t('Interpretation-AddExerciseInfoChapter3')}<br />
          <ol>
            <li>
              {t('Interpretation-AddExerciseInfoStep1')}
            </li>
            <li>
              {t('Interpretation-AddExerciseInfoStep2')}
            </li>
            <li>
              {t('Interpretation-AddExerciseInfoStep3')}
            </li>
          </ol>
        </p>
        <p>
          <img 
            src={googlefit[i18n.language]?.() || googlefit['en']()}
            alt={t('Connecting to Google FIT')} 
          />
        </p>
        <p>
          {t('Interpretation-AddExerciseInfoChapter4')}
        </p>
        <p>
          <img 
            src={exercise[i18n.language]?.() || exercise['en']()}
            alt={t('Exercise data in the daily view')} 
          />
        </p>
      </section>
      <section id="oura">
        <h2>{t('Add sleep and recovery information')}</h2>
        <p>
          <Link to="#helpTips">{t('Back to the top')}</Link>
        </p>
        <p>
          {t('Interpretation-AddSleepAndRecoveryInfoChapter1')} 
        </p>
        <p>
          {t('Interpretation-AddSleepAndRecoveryInfoChapter2')}
        </p>
        <p>
          {t('Interpretation-AddSleepAndRecoveryInfoChapter3')}<br />
          <ol>
            <li>
              {t('Interpretation-AddSleepAndRecoveryInfoStep1')}
            </li>
            <li>
              {t('Interpretation-AddSleepAndRecoveryInfoStep2')}
            </li>
            <li>
              {t('Interpretation-AddSleepAndRecoveryInfoStep3')}
            </li>
          </ol>
        </p>
        <p>
          <img 
            src={oura[i18n.language]?.() || oura['en']()}
            alt={t('Connecting the Oura cloud service')}  
          />
        </p>
        <p>
          {t('Interpretation-AddSleepAndRecoveryInfoChapter4')} 
        </p>
        <p>
          <img 
            src={sleep[i18n.language]?.() || sleep['en']()}
            alt={t('Data produced by Oura in daily view')} 
          />
        </p>
      </section>
    </Fragment>
  );
}

export default Interpretation;